import Api from "./api.js";

/**
 * Chili Piper — demo booking, reached as `ThryvApi.chiliPiper` on every page of both themes
 * (except error pages, which load no JS).
 *
 * Loads nothing until something books. `window.ChiliPiper` is the vendor's global and
 * `window.ChiliPiperDS` the legacy form controller — this claims neither.
 *
 *   // from your own values
 *   ThryvApi.chiliPiper.book({ lead: { FirstName: "Ada", email: "a@x.com" }, router });
 *
 *   // from a form — build the lead yourself, in CP's own field names
 *   ThryvApi.chiliPiper.book({
 *     lead: { FirstName: first.value, LastName: last.value, email: email.value },
 *     router: form.dataset.router,
 *   });
 *
 *   // let CP take over a HubSpot form
 *   ThryvApi.chiliPiper.deploy({ formIds: ["…"], router });
 *
 * OPTIONS
 *
 *   lead       object    CP's own field names — FirstName, LastName, email, Phone, company,
 *                        PersonEmail for trigger flows. CP cannot route without an email, and it
 *                        rejects keys it does not know, so this is its contract to follow rather
 *                        than ours to translate. There is no field mapping here on purpose: one
 *                        silently dropped a field the caller had added.
 *
 *   router     string    REQUIRED, no default — see config.js.
 *   account    string    the CP tenant. Defaults to sandbox off live; see below.
 *   trigger    string    for flows using an in-app button. Changes the payload shape and expects a
 *                        PersonEmail-keyed lead; CP rejects the wrong shape, so this matters.
 *   onSuccess  function
 *   onError    function  called when CP cannot route. book() also resolves false.
 *
 * Both return Promise<boolean> and never reject — a failed load or a refused route resolves false,
 * so callers can fall back without try/catch.
 *
 * ── OVERRIDING THE ACCOUNT ───────────────────────────────────────────────────────────────────
 *
 *   ThryvApi.chiliPiper.book({ lead, router, account: "thryv" });
 *
 * Forces the production tenant regardless of environment. Do this only for a resource that exists
 * ONLY on production — hosted scheduling links and chat workspaces are per-tenant, so pointing at a
 * sandbox twin that was never created gives a 404 rather than a safe no-op.
 *
 * THE COST: on a non-live site this puts a test booking in a real rep's real calendar, and they get
 * a real invite. That is what the default prevents, so say at the call site why you are overriding.
 */
export const ChiliPiper = {
  ...Api,

  /** Reached through ThryvApi.chiliPiper; publishes no global, so there is nothing to do. */
  boot() {
    return this;
  },
};

export default ChiliPiper;
